import { IPrAttendanceEntity } from "@odata/GeneratedEntityTypes";
import FormTableList from "@pages/payroll/payslip/formTableList/FormTableList";
import { memoizeOne } from "@utils/memoizeOne";
import i18next from "i18next";
import React, { Component } from "react";

import TestIds from "../../../testIds";
import { getEntityMemoKey } from "../../../views/formView/Form.utils";
import { FormStorage } from "../../../views/formView/FormStorage";
import { MonthlyOverviewColumns, MonthlyOverviewTitle, MonthlyOverviewWrapper } from "./Attendance.styles";
import { getMonthlyOverviewAbsenceSections, getMonthlyOverviewFondSections } from "./Attendance.utils";
import { IAttendanceCustomData } from "./AttendanceFormView";

interface IProps {
    storage: FormStorage<IPrAttendanceEntity, IAttendanceCustomData>;
}

export default class MonthlyOverview extends Component<IProps> {
    // If needed --> wrap in memoizeOne, however this compute does not seem to be expensive enough to warrant it
    // If readding memoizeOne, make sure to use not only getEntityMemoKey but also the custom data
    // for now ---> removing to avoid unncessary complxity with managing memo keys and caching behaviour
    getFondSections = () => {
        return getMonthlyOverviewFondSections(this.props.storage);
    }

    getAbsenceSections = memoizeOne(() => {
        return getMonthlyOverviewAbsenceSections(this.props.storage);
    }, () => [getEntityMemoKey(this.props.storage)]);

    render(): React.ReactElement {
        return (
            <MonthlyOverviewWrapper data-testid={TestIds.CalendarMonthlyDetail}>
                <MonthlyOverviewTitle>{i18next.t("Attendance:Form.MonthlyOverview")}</MonthlyOverviewTitle>
                <MonthlyOverviewColumns>
                    <FormTableList sections={this.getFondSections()} isEditable={false}/>
                    <FormTableList sections={this.getAbsenceSections()} isEditable={false}/>
                </MonthlyOverviewColumns>
            </MonthlyOverviewWrapper>
        );
    }
}
